import { RiUploadCloud2Line } from 'react-icons/ri';
import ImageWithFallback from '@/components/shared/ImageWithFallback';
export default function SelectAvatar({
  selected,
  disabled,
  toggleModal
}) {
  return <div data-sentry-component="SelectAvatar" data-sentry-source-file="SelectAvatar.tsx">
      <div onClick={() => toggleModal()} className={`relative ta-c m-auto justify-center w-[100px] h-[100px] items-center ${disabled ? '' : 'hover:scale-110'}`}>
        {selected && selected.file !== null ? <ImageWithFallback src={`/genie/${selected && selected.file !== null ? selected.file : 'upload.png'}`} width={91} height={92} alt='upload' className={`${!selected ? 'opacity-1' : ''} ${disabled ? 'opacity-30' : ''} rounded-xl`} /> : <div className='w-[91px] h-[92px] gradient-sides border-[#FFA3C8] border-[2px]'></div>}

        {!selected ? <RiUploadCloud2Line className='w-[24px] h-[24px] absolute top-[35px] left-[38px]' /> : <div className='whitespace-nowrap absolute bottom-0 left-1/2 transform -translate-x-1/2 w-fit text-white text-[10px] bg-gray-900 bg-opacity-75 px-3 py-[1px] rounded-full'>
            {selected.name}
          </div>}
      </div>
    </div>;
}